function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Base from "../Base/Base";
import Grid from "../Grid/Grid";
import GridCell from "../Grid/GridCell";
import Icon from "../Icon/Icon";
import Link from "../Typography/Link";
import PlaformContext from "./PlatformContext";
import ConsoleContext from "./ConsoleContext";
export default function ConsoleHeader({
  children,
  separator,
  shade = "shade-3",
  size = "large",
  ...rest
}) {
  const {
    onConsoleClose
  } = useContext(PlaformContext);
  const consolePosition = useContext(ConsoleContext);
  const classes = classnames("ax-platform__console-header", `ax-platform__console-header--${shade}`, `ax-platform__console-header--${size}`, {
    "ax-platform__console-header--separator": separator
  });

  const showCloseOnRight = () => onConsoleClose && size === "large" && consolePosition === "left";

  const showCloseOnLeft = () => onConsoleClose && size === "large" && consolePosition === "right";

  const CloseLink = () => /*#__PURE__*/React.createElement(GridCell, {
    shrink: true
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: onConsoleClose,
    style: "subtle"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "cross",
    size: "1.5rem"
  })));

  return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
    className: classes
  }), /*#__PURE__*/React.createElement(Grid, {
    gutters: "small",
    responsive: false,
    verticalAlign: "middle"
  }, showCloseOnLeft() && /*#__PURE__*/React.createElement(CloseLink, null), /*#__PURE__*/React.createElement(GridCell, null, children), showCloseOnRight() && /*#__PURE__*/React.createElement(CloseLink, null)));
}